import React, { useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

import { cn } from "@/lib/utils";

import { Calendar as CalendarIcon } from "lucide-react";

import { useRecoilState } from 'recoil';
import { subAtom } from 'core/config/atoms';

import { motion } from "framer-motion";
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import moment from 'moment';

import ServiceHostel from 'services/serviceHostel';

import TopBar from 'core/widgets/ui/TopBar';

export default function PanelReportHBook(props) {

    const [sub] = useRecoilState(subAtom);

    const [bookings, setBookings] = useState([]);
    const [booking, setBooking] = useState([]);

    const [filter, setFilter] = useState({});

    const [date, setDate] = useState({
        from: moment().startOf('month').toDate(),
        to: moment().toDate(),
    });

    const [tab, setTab] = useState('all');
    const [query, setQuery] = useState('');

    const [pageSize, setPageSize] = useState(10);
    const [pageCurrent, setPageCurrent] = useState(0);
    const [pageTotal, setPageTotal] = useState(0);

    const [isDate, setIsDate] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const hostelService = new ServiceHostel();

    const changeTab = (val) => {
        setTab(val);
        setQuery('');
        setDate({
            from: moment().startOf('year').toDate(),
            to: moment().toDate(),
        });
        switch (val) {
            case "all":
                setFilter({});
                break;
            case "inprog":
                setFilter({ 'status': 'inprog' });
                break;
            case "closed":
                setFilter({ 'status': 'closed' });
                break;
            default:
                break;
        }
    }

    const handleOnChange = (e) => {
        var { value, name } = e.target;
        switch (name) {
            case 'pageSize':
                setPageSize(value);
                break;
            case 'search':
                setQuery(value);
                break;
        }
    }

    const pageChange = (pageValue) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": pageValue,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await hostelService.getAllBooking(body, '');
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setBookings(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    const loadData = () => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 1,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await hostelService.getAllBooking(body, '');
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setBookings(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    const onDateChange = (event) => {
        setIsDate(true);
        setDate(event);
    }

    const getChipColor = (sts) => {
        switch (sts) {
            case 'inprog':
                return 'bg-yellow-100 text-yellow-600';
            case 'closed':
                return 'bg-green-100 text-green-600';
            case 'none':
            default:
                return 'bg-white';
        }
    }

    const openPanel = (doc) => {
        hostelService.getBookingById({ "bookid": doc._id }, '').then((res) => {
            setBooking(res.data);
            setIsOpen(true);
        });
    }

    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })
        const a = document.createElement('a')
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    const exportData = (type) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 0,
                "size": 0,
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await hostelService.getAllBooking(body, '');
            var records = res.data.data;
            let items = [];
            records.forEach((item) => {
                items.push({
                    Bookid: item.bookid,
                    CheckIn: moment(item.checkIn).format('DD MMM, yyyy'),
                    CheckOut: moment(item.checkOut).format('DD MMM, yyyy'),
                    Floor: item.roomFloor.title,
                    Room: item.roomFloor.units[item.roomIndex].title,
                    Bed: item.roomFloor.units[item.roomIndex].subunit[item.roomBed].title,
                    CustName: item.customerId[0].name,
                    CustPhone: item.customerId[0].phone,
                    CustEmail: item.customerId[0].email,
                    CustCollageName: item.customerId[0].extra.clgName === "" ? "NA" : item.customerId[0].extra.clgName,
                    CustDocumentNumber: item.customerId[0].extra.docNum === "" ? "NA" : item.customerId[0].extra.docNum,
                    Subtotal: item.total.toFixed(2),
                    Discount: item.discount.toFixed(2),
                    ExtraCharges: item.extraCharge.toFixed(2),
                    Tax: item.total.toFixed(2),
                    Total: item.finaltotal.toFixed(2),
                    status: item.status,
                    createdAt: item.createdAt,
                });
            });

            if (type === "xlsx") {
                const worksheet = XLSX.utils.json_to_sheet(items);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "booking");
                XLSX.writeFile(workbook, "Booking.xlsx");
            } else {
                let headers = ['Bookid, CheckIn, CheckOut, Floor, Room, Bed, CustName, CustPhone, CustEmail, CustCollageName, CustDocumentNumber, Subtotal, ExtraCharges, Discount, Tax, Total, status, createdAt'];
                let recordCsv = items.reduce((acc, record) => {
                    const { Bookid, CheckIn, CheckOut, Floor, Room, Bed, CustName, CustPhone, CustEmail, CustCollageName, CustDocumentNumber, Subtotal, ExtraCharges, Discount, Tax, Total, status, createdAt } = record
                    acc.push([Bookid, CheckIn, CheckOut, Floor, Room, Bed, CustName, CustPhone, CustEmail, CustCollageName, CustDocumentNumber, Subtotal, ExtraCharges, Discount, Tax, Total, status, createdAt].join(','))
                    return acc
                }, []);
                downloadFile({
                    data: [...headers, ...recordCsv].join('\n'),
                    fileName: 'Booking.csv',
                    fileType: 'text/csv',
                });
            }
        })();
    }

    const nextPage = () => {
        if (pageCurrent < pageTotal) {
            pageChange(pageCurrent + 1);
        }
    }

    const prevPage = () => {
        if (pageCurrent > 1) {
            pageChange(pageCurrent - 1);
        }
    }

    const getTax = (data) => {
        const grandTotal = data.finaltotal;
        let taxAmount = 0;
        if (data.tax > 0) {
            taxAmount = grandTotal - grandTotal / (1 + data.tax / 100);
        }
        return taxAmount.toFixed(2);
    }

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        loadData();
    }, [pageSize, query, date, filter]);

    return (
        <>
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-[200] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] min-h-screen absolute right-0 py-[20px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>Booking #{booking.bookid}</h1>
                                    <span onClick={() => {
                                        setBooking({});
                                        setIsOpen(false);
                                    }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                </div>
                                <hr className='my-2' />
                                <div className='flex'>
                                    <p className='font-sans font-medium'>Order Type:
                                        <span className={`ml-4 px-3 inline-flex text-xs leading-5 font-semibold rounded-full uppercase bg-blue-100 text-blue-800`}>
                                            Hostel Booking
                                        </span>
                                    </p>
                                    <p className='ml-8 font-sans font-medium'>Status:
                                        <span className={`ml-4 px-4 inline-flex text-xs leading-5 font-semibold rounded-full uppercase ${getChipColor(booking.status)}`}>
                                            {booking.status}
                                        </span>
                                    </p>
                                </div>
                                <div className='mt-1 text-sm'>
                                    Created At: <b>{moment(booking.createdAt).format('DD MMM, yyyy hh:mm:ss A')}</b>
                                </div>
                                <hr className='my-2' />
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Booking Summery
                                    </span>
                                </div>
                                <div className='mt-2 flex items-center'>
                                    <p className='text-sm font-bold text-gray-950'>Item Name</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-bold text-gray-950'>Item Unit</p>
                                </div>
                                <hr className='my-2' />
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Booking Start</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{moment(booking.checkIn).format('DD MMM, yyyy')}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Booking End</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{moment(booking.checkOut).format('DD MMM, yyyy')}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Floor</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.roomFloor.title}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Room</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.roomFloor.units[booking.roomIndex].title}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Bed</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.roomFloor.units[booking.roomIndex].subunit[booking.roomBed].title}</p>
                                </div>
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-2 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Payment Summery
                                    </span>
                                </div>
                                <div className="w-full mt-2 space-y-1">
                                    <div className="flex justify-between">
                                        <span className="font-medium text-sm">Subtotal</span>
                                        <span className="font-medium text-sm">₹ {booking.total.toFixed(2)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-medium text-sm">Extra Charges Charges</span>
                                        <span className="font-medium text-sm">₹ {booking.extraCharge.toFixed(2)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-medium text-sm">@ Discount (₹)</span>
                                        <span className="font-medium text-sm">₹ {booking.discount.toFixed(2)}</span>
                                    </div>
                                    {
                                        sub.features.isTax && <div className="flex justify-between">
                                            <span className="font-medium text-sm">Tax (₹)</span>
                                            <span className="font-medium text-sm">₹ {getTax(booking)}</span>
                                        </div>
                                    }
                                    <div className="border-t-2 mt-2 py-2 flex items-center justify-between">
                                        <span className="font-medium text-lg">Total</span>
                                        <span className="font-medium text-lg">₹ {booking.finaltotal.toFixed(2)}</span>
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-2 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Customer Summery
                                    </span>
                                </div>
                                <div className='mt-2 flex items-center'>
                                    <p className='text-sm font-bold text-gray-950'>Item Name</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-bold text-gray-950'>Item Unit</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Name</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.customerId[0].name}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Phone</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.customerId[0].phone}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Email</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.customerId[0].email}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Collage Name</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.customerId[0].extra.clgName === "" ? "NA" : booking.customerId[0].extra.clgName}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Document Number</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{booking.customerId[0].extra.docNum === "" ? "NA" : booking.customerId[0].extra.docNum}</p>
                                </div>
                                <div className=''>
                                    <p className='text-sm  font-medium text-gray-950'>Customer Document</p>
                                    <div className='w-full border overflow-hidden rounded relative'>
                                        <img src={booking.customerId[0].extra.docFile.fileurl} alt='document' className='w-full object-fill' />
                                    </div>
                                </div>
                            </div>
                        </ScrollArea >
                    </div>
                </div>
            }
            <ScrollArea className="w-full h-full px-[4px]">
                <div className="grid grid-cols-12 grid-gap-2">
                    <div className="col-span-12 mt-2">
                        <div className="intro-y flex items-center justify-between h-10 border-b pb-4">
                            <h2 className="text-2xl font-medium font-serif truncate ml-2 text-ascent">
                                <motion.i whileHover={{ scale: 1.2 }} className="las la-bars cursor-pointer" onClick={() => { props.onToggle(); }}></motion.i> Hostel Booking Reports
                            </h2>
                            <TopBar />
                        </div>
                        <div className="w-full mt-4 flex justify-between items-center">
                            <div className='h-10 bg-gray-100 rounded'>
                                <ul className="intro-y flex text-sm font-sans">
                                    <li className={`px-3 h-8 m-1 rounded flex items-center justify-center ${tab === 'all' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('all') }}>All</button></li>
                                    <li className={`px-3 h-8 m-1 rounded flex items-center justify-center ${tab === 'inprog' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('inprog') }}>In Progress</button></li>
                                    <li className={`px-3 h-8 m-1 rounded flex items-center justify-center ${tab === 'closed' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('closed') }}>Closed</button></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 mt-2">
                    <div className="w-full shadow-md rounded-md border">
                        <table className="min-w-full divide-y divide-gray-200 px-4">
                            <thead className="bg-gray-50">
                                <tr className=''>
                                    <th scope="col" className="border-b border-gray-200" colSpan={6}>
                                        <div className='w-full flex items-center space-x-2 px-2'>
                                            <form className="py-2 flex-grow flex items-center">
                                                <div className='flex'>
                                                    <Popover>
                                                        <PopoverTrigger asChild>
                                                            <Button id="date" variant={"outline"}
                                                                className={cn(
                                                                    "w-[300px] justify-start text-left font-normal",
                                                                    !date && "text-muted-foreground"
                                                                )}
                                                            >
                                                                <CalendarIcon className="mr-2 h-4 w-4" />
                                                                {date?.from ? (
                                                                    date.to ? (
                                                                        <>
                                                                            {moment(date.from).format('MMM DD, yyyy')} -{" "}
                                                                            {moment(date.to).format('MMM DD, yyyy')}
                                                                        </>
                                                                    ) : (
                                                                        moment(date.from).format('MMM DD, yyyy')
                                                                    )
                                                                ) : (
                                                                    <span>Pick a date</span>
                                                                )}
                                                            </Button>
                                                        </PopoverTrigger>
                                                        <PopoverContent className="w-auto p-0" align="start">
                                                            <Calendar
                                                                initialFocus
                                                                mode="range"
                                                                defaultMonth={date?.from}
                                                                selected={date}
                                                                onSelect={onDateChange}
                                                                numberOfMonths={2}
                                                            />
                                                        </PopoverContent>
                                                    </Popover>
                                                </div>
                                                <div className='w-full flex items-center'>
                                                    <div className='w-[80px]'>
                                                        <p>Search :</p>
                                                    </div>
                                                    <input type="text" value={query} onChange={handleOnChange} name='search' placeholder="Search by booking id." className="w-full h-10 px-4 font-sans text-sm outline-none rounded border" />
                                                </div>
                                            </form>
                                            <div className='flex items-center'>
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger>
                                                        <button className="w-full py-1 px-2 h-10 rounded-md bg-prime hover:bg-primeLight text-white mr-4"><i className="las la-file-download mr-2"></i> Export </button>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent>
                                                        <div
                                                            className='bg-white shadow-md rounded-md absolute' style={{ top: '0px', left: '-64px' }}>
                                                            <div>
                                                                <ul className='flex flex-col items-start p-2'>
                                                                    <DropdownMenuItem>
                                                                        <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                            exportData('xlsx');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <p className="text-sm font-serif ml-2 font-normal">Export to .xlsx</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                    <DropdownMenuItem>
                                                                        <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                            exportData('csv');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <p className="text-sm font-serif ml-2 font-normal">Export to .csv</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Booking ID
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Check In
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Check Out
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Total
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Status
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Created At
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {
                                    bookings.length !== 0 && bookings.map((doc) => {
                                        return <tr className="hover:bg-gray-100">
                                            <td className="px-6 py-4 whitespace-nowrap cursor-pointer">
                                                <div className="text-sm font-bold text-gray-900 cursor-pointer" onClick={() => { openPanel(doc) }}>
                                                    <div className='flex items-center text-prime'>
                                                        {doc.bookid}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-blue-600">
                                                    {moment(doc.checkIn).format('DD MMM, yyyy')}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-blue-600">
                                                    {moment(doc.checkOut).format('DD MMM, yyyy')}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-prime">
                                                    ₹ {doc.finaltotal.toFixed(2)}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase ${doc.status === 'closed' ? 'bg-green-100 text-green-800' : doc.status === 'inprog' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`}>
                                                    {doc.status.toUpperCase()}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-blue-600">
                                                    {moment(doc.createdAt).format('DD MMM, yyyy hh:mm:ss A')}
                                                </div>
                                            </td>
                                        </tr>
                                    })
                                }
                                {
                                    bookings.length === 0 && <tr className="cursor-pointer hover:bg-gray-100">
                                        <td className="px-6 py-4 whitespace-nowrap" colSpan="6">
                                            <div className="text-sm text-red-600 text-center">
                                                No data found.
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                        <div className='flex py-2 px-4 items-center bg-blue-50'>
                            <p className='text-sm font-serif'>Show rows per page</p>
                            <select className='text-sm ml-2 bg-gray-100' name="pageSize" onChange={handleOnChange} value={pageSize}>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={40}>40</option>
                                <option value={50}>50</option>
                            </select>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-serif mr-2'>Page {pageCurrent} of {pageTotal}</p>
                            <div onClick={() => { prevPage() }}><i className={`las la-angle-left w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ${pageCurrent <= 1 ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                            <div onClick={() => { nextPage() }}><i className={`las la-angle-right w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ml-2 text-black ${pageCurrent === pageTotal ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                        </div>
                    </div>
                </div>
            </ScrollArea>
        </>
    )
}
